import { downloadCSV } from 'react-admin';
import jsonExport from 'jsonexport/dist';

const exporter = (data, _, __, resource) =>
    jsonExport(data, { rowDelimiter: ';' }, (err, csv) => {
        if (err || typeof csv !== 'string') return;
        downloadCSV(`\ufeff${csv}`, resource);
    });

export default exporter;
